var exports = {
  "Z5": "majorSegment-M2pmd",
  "Qs": "content-M2pmd",
  "wx": "header-M2pmd",
  "MK": "menu-M2pmd",
  "oE": "compact-M2pmd",
  "Ql": "fluidMenu-M2pmd",
  "KE": "toolbar-M2pmd",
  "Kk": "icon-M2pmd",
  "II": "iconPopupOpen-M2pmd",
};

module.exports = exports;
